
import type { DefaultNodeTypes } from '@payloadcms/richtext-lexical';
import type {
  JSXConverters,
  JSXConvertersFunction,
} from '@payloadcms/richtext-lexical/react';
import {
  RichText as SerializedRichText,

} from '@payloadcms/richtext-lexical/react';
import type { SerializedEditorState } from 'lexical';
import React from 'react';
import { AppLink } from '../AppLink';
// eslint-disable-next-line camelcase
import { Link_Type } from '../../graphql/generated/schema';
import { ButtonLink, Countdown, CustomerReview, DynamicGreeting, IconBlock, ListWithIcon, RatingWidget } from '../../blocks';
import styles from './styles.module.scss';

type NodeTypes = DefaultNodeTypes

type Props = {
  data: SerializedEditorState
} & React.HTMLAttributes<HTMLDivElement>

const jsxConverters: JSXConvertersFunction<NodeTypes> = ({ defaultConverters }) => {
  const converters: JSXConverters<NodeTypes> = {
    ...defaultConverters,
    link: ({ node, nodesToJSX }) => {
      const { fields } = node;
      return (
        <AppLink
          link={{
            // eslint-disable-next-line camelcase
            type: fields.linkType === 'internal' ? Link_Type.Internal : Link_Type.External,
            reference: fields.doc,
            url: fields.url,
            newTab: fields.newTab,
          }}
        >
          {nodesToJSX({ nodes: node.children })}
        </AppLink>
      );
    },
    blocks: {
      'list-with-icon': ({ node }) => <ListWithIcon {...node.fields} />,
      'rating-widget': ({ node }) => <RatingWidget {...node.fields} />,
      'customer-review': ({ node }) => <CustomerReview {...node.fields} />,

    },
    inlineBlocks: {
      'button-link': ({ node }) => <ButtonLink {...node.fields} />,
      countdown: ({ node }) => <Countdown {...node.fields} />,
      icon: ({ node }) => <IconBlock {...node.fields} />,
      'dynamic-greeting': () => <DynamicGreeting />,
    },
  };

  return converters;
};

export const RichText: React.FC<Props> = (props) => {
  const { ...rest } = props;

  return (
    <SerializedRichText
      className={styles.richText}
      converters={jsxConverters}
      {...rest}
    />
  );
};
